import { useT } from '../i18n';
import type { KhoaDich } from '../i18n';

/**
 * Bốn route chỉ có tiêu đề (§3.5). Toàn bộ thân của chúng đúng là như vậy ở bản
 * gốc — đây là chỗ giữ chỗ trung thực, không phải việc còn thiếu.
 *
 * Lưu ý: đây là **những màn duy nhất** có tiêu đề cỡ `text-2xl`; mọi màn đã
 * chuyển đổi đều dùng `PageHeader` với `<h1>` cỡ `text-lg`.
 */
export function StubPage({ khoa }: { khoa: KhoaDich }) {
  const { t } = useT();
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-content-primary">{t(khoa)}</h1>
    </div>
  );
}

/**
 * Giữ chỗ cho các màn thuộc Phase 6 (§18.1) chưa dựng trong lần giao này.
 * Khác `StubPage`: màn ở đây **có** trong bản gốc, chỉ là chưa tới lượt dựng.
 */
export function ChuaDungPage({ khoa }: { khoa: KhoaDich }) {
  const { t } = useT();
  return (
    <div className="flex h-full flex-col bg-subtle">
      <div className="flex-1 overflow-y-auto p-4">
        <div className="page-header flex items-start justify-between gap-4 rounded-lg border border-default bg-surface px-6 py-4 shadow-sm">
          <div className="min-w-0">
            <h1 className="truncate text-lg font-semibold text-content-primary">{t(khoa)}</h1>
            <p className="mt-0.5 text-xs text-content-muted">{t('chan.chuaDungMo')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Màn 404 trong khung ứng dụng.
 *
 * Khác `ChuaDungPage`: màn đó nói "chưa dựng", còn đây là đường dẫn **không
 * tồn tại**. Dùng sai câu thì người dùng ngồi đợi một màn sẽ không bao giờ có.
 */
export function KhongTimThayPage() {
  const { t } = useT();
  return (
    <div className="flex h-full flex-col bg-subtle">
      <div className="flex-1 overflow-y-auto p-4">
        <div className="page-header flex items-start justify-between gap-4 rounded-lg border border-default bg-surface px-6 py-4 shadow-sm">
          <div className="min-w-0">
            <h1 className="truncate text-lg font-semibold text-content-primary">
              {t('chan.khongTimThayTrang')}
            </h1>
            <p className="mt-0.5 text-xs text-content-muted">{t('chan.khongTimThayTrangMo')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
